import { Dispatch, FC, useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../..";
import { getEnv } from "../../../../../AppConfigs";
import { Routes } from "../../../../../AppRoutes";
import { Icon } from "../../../../../components/icon";
import { ProcessContextProvider, ProcessContextType } from "../../../process-context";
import ItToolInformation from "./information";
import ItToolProgress from "./progress";
import { useUpdateDFS } from "../hooks/use-update-DFS";
import { useUser } from "../../../../../hook";
import { Spin } from "antd";
import { useDetailsDFS } from "../hooks/use-details-DFS";

export type ExtraStateContext = {
  employeesSelected: any;
  setEmployeesSelected: Dispatch<any>;
};

export const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REQUEST_URL");

export const demandForSuppliesDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [comment, setComment] = useState("");
  const [employeesSelected, setEmployeesSelected] = useState<any>(null);
  const { updateDFSRequest } = useUpdateDFS();
  const { email } = useUser();
  const { data: itToolRequest, isLoading, isPin: hasPin, approvalStep, approvalType } = useDetailsDFS();

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!itToolRequest) return;
        const pins: any[] = itToolRequest.fields.ePins ? JSON.parse(itToolRequest.fields.ePins) : [];
        const index = pins.findIndex((pin: string) => pin === email?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(email?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };

        updateDFSRequest(
          { id: itToolRequest.id, body: fields },
          { successText: hasPin ? "Bỏ ghim thành công" : "Ghim thành công" },
        );
      } catch (error) {
        console.log(error);
      }
    },
    [email, hasPin, itToolRequest, updateDFSRequest],
  );

  const handleGoBack = () => {
    history.push(Routes.procedureDemandForSupplies.path);
  };

  const ctx = useMemo<ProcessContextType<ExtraStateContext>>(
    () => ({
      Request: itToolRequest,
      approvalStep,
      approvalType,
      comment,
      employeesSelected,
      setComment,
      setEmployeesSelected,
      updatePin: handleUpdatePin,
      isPin: () => hasPin,
    }),
    [approvalStep, approvalType, comment, employeesSelected, handleUpdatePin, hasPin, itToolRequest],
  );

  if (isLoading) return <Spin />;

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Yêu Cầu Duyệt"}
        </div>
      </div>

      <ProcessContextProvider context={ctx}>
        <ItToolProgress />
        <ItToolInformation />
      </ProcessContextProvider>
    </div>
  );
});
